<template>
	<div class="card">
		<div class="card-body">
			<div class="card-title flex items-center justify-between gap-2 text-xl">
				<div class="flex items-center gap-2">
					<StatusLight v-if="currentLocation?._id" type="location" :_id="currentLocation._id" />
					<span v-if="currentLocation?._id">{{ currentLocation.name }}</span>
					<span v-else-if="!isLoading && !hasLocationId" class="text-base-content/60 text-sm">
						{{ _tr('location.noDataAvailable') }}
					</span>
				</div>
				<div class="flex items-center gap-2">
					<button
						v-if="canAssign"
						class="btn btn-sm btn-soft btn-primary"
						:disabled="!currentLocation?._id"
						@click="openAssignModal">
						{{ _tr('location.assignDevices') }}
					</button>
					<span v-if="isLoading" class="loading loading-spinner loading-xs"></span>
				</div>
			</div>

			<!-- //? NO Location FOUND -->
			<div
				v-if="!isLoading && hasLocationId && !currentLocation?._id"
				role="alert"
				class="alert alert-error alert-soft mt-3">
				<TriangleAlert />
				<div>
					<span class="font-bold">{{ _tr('location.noLocationFound') }}:&nbsp;</span>
					<code class="font-bold">...#{{ locationId?.slice(-4) }}</code>
				</div>
			</div>
		</div>
	</div>
	<LocationAssignModal
		modalId="location-assign-modal"
		:locationId="locationId"
		@refresh="onAssignModalRefresh" />
	<!-- <div class="relative inline bg-amber-600"> -->
	<!-- <Popper arrow>
			<button class="btn btn-sm btn-warning">Open Popper</button>
			<template #content="{ close }">
				<div class="">asdfjl</div>
			</template>
		</Popper>
	</div>

	<VPopover>
		<button class="btn btn-primary">Toggle Popover</button>
		<template #popover>
			<div class="p-4">
				<h3 class="h3">Popover Content</h3>
				<p>This is a popover example.</p>
			</div>
		</template>
	</VPopover>

	<VPopover>
		<button class="btn btn-secondary">Another Popover</button>
		<template #popover>
			<div class="p-4">
				<p>This is the popover content.</p>
				<button class="btn btn-secondary" @click="$emit('close')">Close</button>
			</div>
		</template>
	</VPopover>

	<div class="m-34"></div>


  -->
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import { _translations } from './_translations'
	import { useI18n } from 'vue-i18n'
	import { ILocation, useLocationStore } from '@/stores/location.store'
	import { TriangleAlert } from 'lucide-vue-next'
	import { useBaseStore } from '@/stores/base.store'
	import StatusLight from '@/components/StatusLight.vue'
	import { useAuthStore } from '@/stores/auth.store'
	import { useVfm } from '@/libs/modals'
	import LocationAssignModal from './LocationAssignModal.vue'

	const { t: _tr } = useI18n(_translations)
	const locationStore = useLocationStore()
	const baseStore = useBaseStore()
	const authStore = useAuthStore()
	const vfm = useVfm()
	const currentLocation = computed<ILocation | null>(() => locationStore.currentLocation || null)
	const locationId = computed<string | null>(() => baseStore.getActiveIds.locationId || null)
	const hasLocationId = computed(() => !!locationId.value)
	const isLoading = computed(
		() => !!(locationId.value && locationStore.loadingMap[`getLocation-${locationId.value}`]),
	)
	const canAssign = computed(() => authStore.isAdmin && !!locationId.value)

	const openAssignModal = () => {
		vfm.open('location-assign-modal')
	}

	// Triggered by LocationAssignModal when it closes. Re-fetches anything
	// the LocationView sidebar depends on (full list refresh — store
	// reactivity propagates the changes to all consumers automatically).
	//
	// `fetchMegalist` is the important one: the navigation sidebar tree
	// (projects → locations → hubs → modules) builds from `baseStore.megalist`
	// and stays stale after assignments otherwise. `fetchStates` covers the
	// online/offline status lights. `getLocation` refreshes the current doc.
	const onAssignModalRefresh = async () => {
		try {
			if (locationId.value) await locationStore.getLocation(locationId.value)
		} catch (e) {
			console.error('refresh location failed', e)
		}
		try {
			await baseStore.fetchMegalist()
		} catch (e) {
			console.error('refresh megalist failed', e)
		}
		try {
			await baseStore.fetchStates()
		} catch (e) {
			console.error('refresh states failed', e)
		}
	}
</script>
